import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import HomestayRate, { HomestayRateSync } from '../models/HomestayRate.js';
import Urls from './../api/Urls';

const headersHomestayRate = {
    tenantId: Config.HOMESTAY_TENANT_ID,
}

export function getHomestayRates(data) {
    let homestayId = data.homestayId;
    delete data.homestayId;
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_RATE_LIST,
        endpointParams: { homestayId },
        parser: data => homestayRatesDataParser(data, homestayId),
        params: data,
        headers: headersHomestayRate
    }).get();
}

export function getHomestayRateDetail(id) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_RATE_DETAIL,
        endpointParams: { id },
        parser: (data) => new HomestayRate(data),
        headers: headersHomestayRate
    }).get();
}

export function createHomestayRateTranslate(homestayRate) {
    const rate = homestayRate.export(true).translate()
    rate.ratePlanId = rate.homestayRatePlanId
    delete rate.homestayRatePlanId
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_RATE_TRANSLATE_CREATE,
        headers: headersHomestayRate
    }).post(rate);
}

export function updateHomestayRateTranslate(homestayRate) {
    const rate = homestayRate.export(true).translate()
    rate.ratePlanId = rate.homestayRatePlanId
    delete rate.homestayRatePlanId
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_RATE_TRANSLATE_UPDATE,
        headers: headersHomestayRate
    }).put(rate);
}

export function deleteHomestayRateTranslate(id) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_RATE_TRANSLATE_DELETE,
        headers: headersHomestayRate,
        endpointParams: { id },
    }).delete();
}

export function sortHomestayRate(homestayRates) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_RATE_SORT,
        headers: headersHomestayRate
    }).put(homestayRates);
}

export function syncHomestayRatesAllHotels() {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_RATE_SYNC_ALL,
        headers: headersHomestayRate
    }).post();
}

export function syncHomestayRatesAll(payload) {
    let id = payload.homestayId || null;
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_RATE_SYNC,
        headers: headersHomestayRate,
        parser: data => homestayRatesDataSyncParser(data),
        endpointParams: { id }
    }).post({ RateCodes: payload.rateCodes || [] });
}

export function getHomestayRatesByHomestays(homestayIds) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_RATE_LIST_BY_HOMESTAY,
        headers: headersHomestayRate
    }).post(homestayIds);
}

//cancel-policy
export function updateCancelPolicy(cancelPolicys) {
    let id = cancelPolicys.id || null;
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_CANCEL_POLICY_UPDATE,
        headers: headersHomestayRate,
        endpointParams: { id }
    }).put(cancelPolicys);
}

export function syncCancelPolicy(syncPolicys) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_CANCEL_POLICY_SYNC,
        headers: headersHomestayRate
    }).post(syncPolicys);
}

export function updateHomestayRateActive(data) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_UPDATE_RATE_ACTIVE,
        headers: headersHomestayRate,
        endpointParams: { id: data.id },
        params: data.data,
    }).put();
}

export function updateHomestayRateExtend(data) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_UPDATE_RATE_EXTEND,
        headers: headersHomestayRate,
        endpointParams: { id: data.id },
        params: data.data,
    }).put();
}

export function updateUsageStatus(data) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_UPDATE_USAGE_STATUS,
        headers: headersHomestayRate
    }).put(data);
}

export function syncHomestayRateLanguage(data) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_SYNC_RATE_LANGUAGE,
        headers: headersHomestayRate
    }).post(data)
}

const homestayRatesDataParser = (data, homestayId) => ({
    dataList: (data?.result || []).map(item => new HomestayRate({ ...item, homestayId })),
    pageIndex: data.pageIndex + 1,
    pageSize: data.pageSize,
    totalCount: data.totalCount,
})

const homestayRatesDataSyncParser = (data) => ({
    result: (data || []).map(item => new HomestayRateSync(item))
})

export function autoTransalate(data) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_RATE_AUTO_TRANSLATE,
        headers: headersHomestayRate
    }).post(data);
}

export function updateAutoTranslate(data) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_RATE_AUTO_TRANSLATE,
        headers: headersHomestayRate
    }).put(data);
}
